'use es6';

import { useDrop } from 'react-dnd';
import { DragTypes } from 'FormsUI/constants/DragAndDrop';
import { trackEditorInteraction } from 'FormsUI/utils/TrackingUtils';
import { DRAGGED_FIELD_INTO_DEAD_ZONE } from 'FormsUI/constants/TrackingInteractionKeys/Editor/FormTab';
import { jsx as _jsx } from "react/jsx-runtime";
const DeadSpaceDropZone = ({
  appendFormFieldGroup
}) => {
  const [, drop] = useDrop({
    accept: [DragTypes.NEW_FORM_FIELD],
    drop: (item, monitor) => {
      if (monitor.didDrop()) {
        return;
      }
      trackEditorInteraction(DRAGGED_FIELD_INTO_DEAD_ZONE);
      const {
        propertyId,
        fieldType
      } = item;
      appendFormFieldGroup(propertyId, {
        fieldType,
        showConfigPanel: false
      });
    }
  });
  return /*#__PURE__*/_jsx("div", {
    ref: drop,
    style: {
      width: '100%',
      height: '100%'
    }
  });
};
export default DeadSpaceDropZone;